export default __webpack_public_path__ + "static/style3.2_Granddad-4fc88e349265e3a3b3e3e44c7a3df310.wav";